/* Ryse - Theoric: monta o bloco de PILARES a partir de [data-tpn-pil]
   (1 por linha: "Titulo | descricao" - descricao opcional).
   Icone escolhido pela palavra-chave do TITULO.

   14/08/2026 - ORDEM DE PRIORIDADE CORRIGIDA.
   Antes, a regra de tempo (/prolong|dura|horas/) vinha ANTES das regras de
   beneficio, entao "Hidratacao prolongada" e "Conforto prolongado" caiam os dois
   no relogio - e o bloco exibia icones repetidos, que nao informam nada.
   Agora o BENEFICIO decide o icone e o tempo so entra quando nada mais bate:
       Hidratacao prolongada .............. gota
       Toque seco e sedoso ................ pluma
       Nutricao inteligente ............... folha
       Fortalecimento da barreira ......... escudo
       Conforto prolongado ................ coracao
       Luminosidade natural ............... brilho
*/
(function () {
  'use strict';
  function svgP(inner) {
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';
  }
  var IC = {
    escudo: svgP('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>'),
    relogio: svgP('<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'),
    gota: svgP('<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5S12.5 5.5 12 3c-.5 2.5-2 4.9-4 6.5S5 13 5 15a7 7 0 0 0 7 7z"/>'),
    pluma: svgP('<path d="M3 9q3-3 6 0t6 0t6 0"/><path d="M3 15q3-3 6 0t6 0t6 0"/>'),
    brilho: svgP('<path d="M12 3l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.4z"/>'),
    gema: svgP('<path d="M12 2.6 20.7 7.3v9.4L12 21.4 3.3 16.7V7.3z"/>'),
    coracao: svgP('<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/>'),
    folha: svgP('<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.5 19 2c1 2 2 4.2 2 8 0 5.5-4.8 10-10 10z"/><path d="M2 21c0-3 1.9-5.4 5.1-6"/>'),
    check: svgP('<path d="M20 6 9 17l-5-5"/>')
  };
  /* beneficio primeiro; tempo por ultimo */
  function pick(t) {
    t = (t || '').toLowerCase();
    if (/barreira|prote|lip[ií]dic|resseca|escudo/.test(t)) return IC.escudo;
    if (/hidrata|umidad|[áa]gua/.test(t)) return IC.gota;
    if (/lumin|vi[çc]o|brilho|radian|glow|revitaliz/.test(t)) return IC.brilho;
    if (/nutri|natural|vegetal|marinh|alga|botan/.test(t)) return IC.folha;
    if (/maci|toque|aveludad|leve|sem grude|absor|sedos|seco/.test(t)) return IC.pluma;
    if (/firme|elasticid/.test(t)) return IC.gema;
    if (/acalma|calma|conforto|sens[íi]vel|repara/.test(t)) return IC.coracao;
    if (/longa|dura|dia todo|prolong|horas/.test(t)) return IC.relogio;
    return IC.check;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function linha(it) {
    var cls = it.sub ? 'tpn-pil__li' : 'tpn-pil__li tpn-pil__li--so';
    var txt = '<span class="tpn-pil__txt"><span class="tpn-pil__tit">' + esc(it.tit) + '</span>' +
      (it.sub ? '<span class="tpn-pil__sub">' + esc(it.sub) + '</span>' : '') + '</span>';
    return '<div class="' + cls + '"><span class="tpn-pil__ic">' + pick(it.tit) + '</span>' + txt + '</div>';
  }

  function montar(host) {
    if (host.dataset.tpnPilPronto) return;
    host.dataset.tpnPilPronto = '1';
    var rot = host.getAttribute('data-tpn-pil-rotulo') || '';
    var itens = host.textContent.trim().split(/\r?\n/).map(function (l) {
      l = l.trim(); if (!l) return null; var p = l.split('|');
      return { tit: (p[0] || '').trim(), sub: (p[1] || '').trim() };
    }).filter(function (x) { return x && x.tit; });
    if (!itens.length) { host.remove(); return; }
    host.innerHTML = (rot ? '<p class="tpn-pil__rot">' + esc(rot) + '</p>' : '') + itens.map(linha).join('');
    host.hidden = false;
  }

  function init() {
    var host = document.querySelector('[data-tpn-pil]:not([data-tpn-pil-pronto])');
    if (host) montar(host);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();